// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import Printer from "@insite/mobius/Icons/Printer";
import { pipeAndWireSheetStyles } from "@steiner/App/Widgets/PipeAndWireSheet/PipeAndWireSheet";
import Minus from "@steiner/XDL/Icons/Minus";
import Plus from "@steiner/XDL/Icons/Plus";
import { plpAccordion } from "@steiner/XDL/PreStyle/accordion";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { avoidBreakInsidePrintElement, color, mergeWithCss, styledScrollbar } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

pipeAndWireSheetStyles.tableContainer = {
    css: css`
        table {
            width: 100%;
            border-spacing: 0px;

            tr,
            td {
                &.title {
                    td {
                        font-size: 12px;
                        line-height: 17px;
                        font-weight: ${fontConfig.weight.bold};
                    }
                    background: ${color("common.ui10")};
                    color: ${color("common.ui1")};
                    font-size: 12px;
                    line-height: 17px;
                    font-weight: ${fontConfig.weight.bold};
                }
                > div {
                    white-space: nowrap;
                }
            }

            tr:not(.title):nth-of-type(even) {
                background: ${color("common.ui2")};
            }

            td {
                text-align: center;
                border: 1px solid ${color("common.border")};
                padding: 8px 12px;
                white-space: nowrap;

                p {
                    font-size: 14px;
                    line-height: 22px;
                    margin-bottom: 0;
                }

                a {
                    font-size: 14px;
                    line-height: 22px;
                    color: ${color("common.ui10")};
                    font-weight: ${fontConfig.weight.semiBold};

                    :hover,
                    :focus {
                        color: ${color("common.ui9")};
                    }
                }
            }

            .text-left {
                text-align: left;
                background: ${color("common.ui1")};
            }
        }

        @media print {
            @page {
                size: landscape;
            }

            table {
                width: auto;

                tr,
                td {
                    background: ${color("common.ui1")};

                    &.title {
                        td {
                            font-size: 10px;
                            line-height: 13px;
                        }
                        color: ${color("text.main")};
                        background: ${color("common.ui1")};
                    }
                }

                td {
                    padding: 1px;

                    &,
                    a,
                    p {
                        font-size: 10px;
                        line-height: 13px;
                        font-weight: ${fontConfig.weight.regular};
                    }
                }
            }
        }

        ${avoidBreakInsidePrintElement}
    `,
};

pipeAndWireSheetStyles.sheetCodeContainer = {
    css: css`
        overflow-y: auto;
        ${styledScrollbar()}

        @media print {
            overflow: unset;
        }
    `,
};

pipeAndWireSheetStyles.printContainer = {
    css: css`
        display: flex;
        justify-content: flex-end;
        margin-bottom: 16px;
        margin-top: 5px;
    `,
};

pipeAndWireSheetStyles.printLink = {
   typographyProps: {
           size: 12,
           lineHeight: "15px",
       },
       icon: {
           position: "left",
           iconProps: {
               src: Printer,
               size: 14,
               css: css`
                   margin-right: 6px;
                   opacity: 0.66;
               `,
           },
       },
       css: css`
           margin-left: auto;
           justify-content: end;
       `,
};

pipeAndWireSheetStyles.accordionSection = {
    ...mergeWithCss(plpAccordion, {
        toggleIconProps: {
            color: "common.white",
            src: Minus,
            size: 25,
            css: css`
                &,
                & > svg {
                    height: 24px;
                }
            `,
        },
        expandIconProps: {
            color: "common.white",
            src: Plus,
            size: 25,
            css: css`
                &,
                & > svg {
                    height: 24px;
                }
            `,
        },
    }),
};


pipeAndWireSheetStyles.strPipeAndWireSheetTitle = {
    css: css`
        display: none;
    `,
}